import type { PropsWithChildren } from 'react';
import type React from 'react';

import { TheSupportersContextBaseProvider } from './context';
import { useTheSupportersContextValue } from './useTheSupportersContextValue';

export const TheSupportersContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const value = useTheSupportersContextValue();

	return <TheSupportersContextBaseProvider value={value}>{children}</TheSupportersContextBaseProvider>;
};
